/**
 * @license Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */
/**
 * @module special-characters/specialcharacterstext
 */
import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
/**
 * A plugin that provides special characters for the "Text" category.
 *
 *		ClassicEditor
 *			.create( {
 *				plugins: [ ..., SpecialCharacters, SpecialCharactersText ],
 *			} )
 *			.then( ... )
 *			.catch( ... );
 *
 * @extends module:core/plugin~Plugin
 */
export default class SpecialCharactersText extends Plugin {
    /**
	 * @inheritDoc
	 */
    init() {
        const editor = this.editor;
        const t = editor.t;
        editor.plugins.get('SpecialCharacters').addItems('Text', [
            {
                character: '\u2039',
                title: t('dd')
            },
            {
                character: '\u203A',
                title: t('de')
            },
            {
                character: '\xAB',
                title: t('df')
            },
            {
                character: '\xBB',
                title: t('dg')
            },
            {
                character: '\u2018',
                title: t('dh')
            },
            {
                character: '\u2019',
                title: t('di')
            },
            {
                character: '\u201C',
                title: t('dj')
            },
            {
                character: '\u201D',
                title: t('dk')
            },
            {
                character: '\u201A',
                title: t('dl')
            },
            {
                character: '\u201E',
                title: t('dm')
            },
            {
                character: '\xA1',
                title: t('dn')
            },
            {
                character: '\xBF',
                title: t('do')
            },
            {
                character: '\u2025',
                title: t('dp')
            },
            {
                character: '\u2026',
                title: t('dq')
            },
            {
                character: '\u2021',
                title: t('dr')
            },
            {
                character: '\u2030',
                title: t('ds')
            },
            {
                character: '\u2031',
                title: t('dt')
            },
            {
                character: '\u203C',
                title: t('du')
            },
            {
                character: '\u2048',
                title: t('dv')
            },
            {
                character: '\u2049',
                title: t('dw')
            },
            {
                character: '\u2047',
                title: t('dx')
            },
            {
                character: '\xA9',
                title: t('dy')
            },
            {
                character: '\xAE',
                title: t('dz')
            },
            {
                character: '\u2122',
                title: t('ea')
            },
            {
                character: '\xA7',
                title: t('eb')
            },
            {
                character: '\xB6',
                title: t('ec')
            },
            {
                character: '\u204B',
                title: t('ed')
            }
        ]);
    }
}